import {
  FETCH_LOCATION_BASED_REQUEST,
  FETCH_LOCATION_BASED_SUCCESS,
  FETCH_LOCATION_BASED_FAILURE,
  FETCH_LOCATION_BASED_EMPLOYEES_REQUEST,
  FETCH_LOCATION_BASED_EMPLOYEES_SUCCESS,
  FETCH_LOCATION_BASED_EMPLOYEES_FAILURE
} from "../constants/LocationBasedConstants";

import LocationBasedService from "../service/LocationBasedService";

export const fetchLocationBased = (date) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_LOCATION_BASED_REQUEST });

    
    const data = await LocationBasedService.getAll(date);

    dispatch({
      type: FETCH_LOCATION_BASED_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_LOCATION_BASED_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};

export const fetchLocationBasedEmployees = (date, location) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_LOCATION_BASED_EMPLOYEES_REQUEST });

    
    const data = await LocationBasedService.getEmpByLocation(date, location);

    dispatch({
      type: FETCH_LOCATION_BASED_EMPLOYEES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_LOCATION_BASED_EMPLOYEES_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};
